// == Import npm
import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Select, Radio, Steps, Empty, Typography, DatePicker } from "antd";
import moment, { max } from "moment";
import { useDispatch, useSelector } from "react-redux";
import { createVisit, resetVisitorList, searchVisitor } from "services/features/VisitsSlice";
import classNames from "classnames";
import debounce from "lodash.debounce";

// == Import SCSS
import "./modalAdd.less";

// == import components
import ModalAddVisitor from "../ModalAddVisitor/ModalAddVisitor";

// == Import icons
import { MdPersonAdd } from "react-icons/md";

// == import i18n
import { useTranslation } from "react-i18next";
import { range } from "ramda";
import { roundMoment } from "helpers";
import DurationPicker from "components/DurationPicker/DurationPicker";

const { Step } = Steps;

const ModalAdd = ({
  isVisible,
  setVisible,
  user,
  setSearch,
  setIsModalPrintVisible,
  setVisitorCheck,
  initialSearch,
}) => {
  const [t] = useTranslation();

  const [isModalAddvisitorVisible, setIsModalAddvisitorVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [isDisplayCaract, setIsDisplayCaract] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [loaderSearch, setLoaderSearch] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const { visitorList, maxVisitDuration } = useSelector(state => state.visits);

  useEffect(() => {
    dispatch(resetVisitorList());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setLoaderSearch(false);
  }, [visitorList]);

  const handleAdd = async values => {
    const visit = await dispatch(
      createVisit(
        values.startDate.toISOString(),
        values.startDate.clone().add(1, "hours").toISOString(),
        values.visitors.map(v => v.value),
        user.id,
        values.duration,
      ),
    );

    setVisitorCheck(
      visit.visitors.map(vis => ({
        visitId: visit.id,
        resident: user,
        ...vis,
      })),
    );
    setIsModalPrintVisible(true);
    setCurrent(0);
    form.resetFields();
    setVisible(false);
  };

  const handleSearch = async value => {
    if (value) {
      if (value.length >= 3) {
        setLoaderSearch(true);
        dispatch(searchVisitor(value));

        setIsDisplayCaract(false);
        setIsDisplay(true);
      }
    }
    if (value.length === 0) {
      setIsDisplayCaract(true);
      setLoaderSearch(false);
    }
    if (value.length < 3 && value.length > 0) {
      setIsDisplayCaract(true);
      dispatch(searchVisitor(""));
      setLoaderSearch(false);
    }
  };

  const handleSearchDebounced = debounce(handleSearch, 500);

  const handleOk = () => {
    setVisible(false);
    form.resetFields();
    setSearchValue("");
    setSearch("");
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setSearchValue("");
    setSearch("");
  };

  const { Option } = Select;

  const showModal = () => {
    setIsModalAddvisitorVisible(true);
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const onCreateUser = user => {
    const values = form.getFieldsValue();
    form.setFieldsValue({
      ...values,
      visitors: [
        ...(values.visitors || []),
        {
          value: user.id,
          label: [user.firstname, " ", user.lastname],
          key: user.id,
        },
      ],
    });
  };

  const cssClassDisplayCaract = classNames("noResult__text", {
    "noResult__text--display": isDisplayCaract,
  });

  const cssClassDisplaytext = classNames("noResult__text", {
    "noResult__text--display": !isDisplayCaract,
  });

  const cssClassDisplay = classNames("searchBar__result__loader", {
    "searchBar__result__loader--display": isDisplay,
  });

  useEffect(() => {
    if (initialSearch) {
      handleSearchDebounced(initialSearch);
    }
  }, [handleSearchDebounced, initialSearch]);

  return (
    <div>
      <Modal
        bodyStyle={{ minHeight: "700px" }}
        open={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        width={600}
      >
        <Steps current={current} labelPlacement="vertical" style={{ overflow: "inherit" }}>
          <Step title={t("AddAVisitor")} />
          <Step title={t("AddAVisit")} />
        </Steps>

        <div>
          <Form
            style={{ marginTop: "50px", height: "450px" }}
            form={form}
            onFinish={handleAdd}
            onValuesChange={changedValues => {
              if (changedValues.startDate) {
                form.setFieldsValue({ endDate: moment(changedValues.startDate).add(2, "hours") });
              }
            }}
            initialValues={{
              startDate: roundMoment(moment(), 15, "minutes", "round"),
              endDate: roundMoment(moment(), 15, "minutes", "round").add(2, "hours"),
              resident: user.id,
              duration: 1,
            }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            layout="horizontal"
          >
            <div
              style={{
                display: current < 1 ? "flex" : "none",
                flexFlow: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <div>
                <Form.Item label="Résident" name="resident" style={{ display: "none" }}>
                  <Radio.Group>
                    <Radio value={user.id}>
                      {user.firstname} {user.lastname}
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  style={{ display: "block", margin: "0 auto 16px auto", width: "100%" }}
                  name="visitors"
                  className="tag-select"
                >
                  <Select
                    onSelect={() => {
                      // setSearch("");
                      setSearchValue("");
                    }}
                    autoFocus={initialSearch.length > 0}
                    defaultOpen={!!initialSearch}
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder={t("SearchByFirstOrLastNameOfTheVisitor")}
                    onSearch={value => {
                      //setSearch(value);
                      setSearchValue(value);
                      handleSearchDebounced(value);
                    }}
                    searchValue={searchValue || initialSearch}
                    filterOption={false}
                    //showSearch
                    // autoClearSearchValue={false}
                    // searchValue={searchValue}
                    virtual={false}
                    onBlur={() => {
                      // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                      window.scrollTo(0, 0);
                    }}
                    labelInValue={true}
                    dropdownRender={menu => (
                      <div>
                        {visitorList.length > 0 ? (
                          menu
                        ) : (
                          <>
                            {loaderSearch ? (
                              <p className={cssClassDisplay}>{t("Loading")}</p>
                            ) : (
                              <>
                                <p
                                  className={cssClassDisplayCaract}
                                  style={{ textAlign: "center" }}
                                >
                                  {" "}
                                  {t("EnterLetters")} <br /> {t("RespectTheAccents")}
                                </p>
                                <Empty
                                  className={cssClassDisplaytext}
                                  description={t("NoVisitor")}
                                />{" "}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  >
                    {visitorList.map((user, index) => (
                      <Option key={user.id} value={user.id}>
                        {user.firstname} {user.lastname}
                        {user.company === undefined ? null : `(${user.company})`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Typography.Text
                  style={{ textAlign: "center", fontSize: "16px", marginLeft: "16px" }}
                >
                  {t("FindVisitors")}
                </Typography.Text>
              </div>

              <Form.Item noStyle shouldUpdate>
                {() => (
                  <div
                    style={{
                      display: "flex",
                      flexFlow: "row",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      icon={<MdPersonAdd style={{ marginRight: "10px", verticalAlign: "-2px" }} />}
                      size="large"
                      style={{ marginRight: "16px", width: "250px" }}
                      type="default"
                      onClick={showModal}
                      onBlur={() => {
                        // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                        window.scrollTo(0, 0);
                      }}
                    >
                      {t("AddAVisitor")}
                    </Button>
                    <Button
                      size="large"
                      type="primary"
                      style={{ width: "250px" }}
                      disabled={(form.getFieldValue("visitors") || []).length === 0}
                      className={classNames("btn__next", {
                        "btn__next--disabled": (form.getFieldValue("visitors") || []).length === 0,
                      })}
                      onClick={() => next()}
                      onBlur={() => {
                        // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                        window.scrollTo(0, 0);
                      }}
                    >
                      {t("Next")}
                    </Button>
                  </div>
                )}
              </Form.Item>
            </div>
            <div
              style={{
                display: current === 1 ? "flex" : "none",
                flexFlow: "column",
                height: "100%",
              }}
            >
              <>
                <Form.Item
                  trigger="onSelect"
                  label={t("SelectDate")}
                  rules={[{ required: true }]}
                  name="startDate"
                  style={{ display: "block" }}
                >
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="DD/MM HH:mm"
                    placeholder={t("SelectDate")}
                    minuteStep={15}
                  />
                </Form.Item>
                <Form.Item
                  label={t("SelectDuration")}
                  rules={[{ required: true }]}
                  name="duration"
                  style={{ display: "block" }}
                  hidden={maxVisitDuration === 1}
                >
                  <DurationPicker maxDuration={maxVisitDuration} style={{ width: "160px" }} />
                </Form.Item>
              </>

              <div
                style={{
                  display: "flex",
                  marginTop: "24px",
                  flexFlow: "row",
                  justifyContent: "center",
                }}
              >
                <Button
                  type="default"
                  size="large"
                  style={{ marginRight: "16px", width: "250px" }}
                  onClick={() => prev()}
                  onBlur={() => {
                    // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                    window.scrollTo(0, 0);
                  }}
                >
                  {t("Previous")}
                </Button>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  onBlur={() => {
                    // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                    window.scrollTo(0, 0);
                  }}
                  style={{ width: "250px" }}
                >
                  {t("DoneVisits")}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
      <ModalAddVisitor
        isVisible={isModalAddvisitorVisible}
        setVisible={setIsModalAddvisitorVisible}
        onCreateUser={onCreateUser}
        setSearch={setSearch}
        setSearchValue={setSearchValue}
      />
    </div>
  );
};

export default ModalAdd;
